import React from 'react';
import PropTypes from 'prop-types';
import useDeferredPrompt from './useDeferredPrompt';

export default function InstallButton({ tag: Component = 'button', onAccept, onDismiss, children, ...rest }) {
    const deferredPrompt = useDeferredPrompt();

    if (!deferredPrompt) return null;

    async function onClick(e) {
        e.preventDefault();
        deferredPrompt.prompt();

        const choiceResult = await deferredPrompt.userChoice;

        if (choiceResult.outcome !== 'accepted') {
            onAccept && onAccept();
        } else {
            onDismiss && onDismiss();
        }
    }

    return (
        <Component onClick={onClick} {...rest}>
            {children}
        </Component>
    );
}

InstallButton.propTypes = {
    tag: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    children: PropTypes.any,
    onAccept: PropTypes.func,
    onDismiss: PropTypes.func,
};
